const ROLES = {
  global_admin: "JOBDRONA_GLOBAL_ADMIN",
  org_admin: "JOBDRONA_ORG_ADMIN",
  b2b_candidate: "JOBDRONA_B2B_CANDIDATE",
  candidate: "JOBDRONA_CANDIDATE",
};

export { ROLES };
